'use client';

import ArchiveOutlinedIcon from '@mui/icons-material/ArchiveOutlined';
import CommunityIcon from '@mui/icons-material/PhotoFilter';
import { useRoundProgress } from '@wt/game/providers/roundProgress/RoundProgressProvider';
import getPuzzleNumber from '@wt/game/utils/getPuzzleNumber';
import useAnimatedRouter from '@wt/shared/hooks/useAnimatedRouter';
import { getSiteMode } from '@wt/utilities/siteMode';
import dayjs from 'dayjs';

export function GameModeTag() {
  const { animatedRoute } = useAnimatedRouter();
  const { gameMode, puzzleId, communityGame } = useRoundProgress();

  // No tag for normal daily mode
  if (gameMode == 'daily') return null;

  const title = gameMode == 'community' ? 'Community' : 'Archive mode';
  let siteName = '';
  if (getSiteMode() == 'whentaken') {
    siteName = 'WhenTaken';
  } else if (getSiteMode() == 'wheretaken') {
    siteName = 'WhereTaken';
  } else if (getSiteMode() == 'whentaken-movies') {
    siteName = 'WhenTaken 🎬';
  }
  const description =
    gameMode == 'community'
      ? `${communityGame?.name} by ${communityGame?.username}`
      : `${siteName} #${getPuzzleNumber(puzzleId ?? '')} | ${dayjs(puzzleId).format('DD.MM.YYYY')}`;

  const Icon = gameMode == 'community' ? CommunityIcon : ArchiveOutlinedIcon;

  return (
    <div className="flex flex-row items-center rounded-full bg-[#FFEECC] lg:rounded-2xl">
      <div
        onClick={() => animatedRoute(`/${gameMode}`)}
        className="items-end justify-center rounded-full bg-[#FFCC6A] px-2 py-1 text-center text-[10px] font-semibold text-[#322E38] hover:cursor-pointer hover:bg-[#FFCC6A]/70 lg:rounded-2xl lg:px-3 lg:py-2 lg:text-base"
      >
        <Icon className="pr-1" /> {title}
      </div>
      <div className="px-2 py-1 text-center text-[10px] text-[#4B4554] lg:px-3 lg:py-2 lg:text-base">
        {description}
      </div>
    </div>
  );
}
